import Types from "../../action/types";
import Cookies from "js-cookie";

const defaultState = {
  authorization: Cookies.get("authorization"),
  // currentUserInfo: JSON.parse(localStorage.getItem('currentUserInfo')) || {}
};

export default function onAction(state = defaultState, action) {
  switch (action.type) {
    case Types.AUTHORIZATION:
      return {
        ...state,
        authorization: action.authorization,
        // currentUserInfo: action.currentUserInfo
      };
    default:
      return state;
  }
}
